





















import { defineComponent, onMounted, ref } from "@vue/composition-api";
import useNsfwEntryGate from "@/hooks/useNsfwEntryGate";
import BaseButton from "@/components/BaseButton";
import SiteLogo from "@/components/SiteLogo";

export default defineComponent({
  name: "NsfwEntryGate",
  components: { BaseButton, SiteLogo },
  setup() {
    const { enter, exit, declined } = useNsfwEntryGate();
    const loading = ref(false);

    const onEnter = async () => {
      loading.value = true;
      try {
        await enter();
      } finally {
        loading.value = false;
      }
    };

    // visitor already answered "Exit": send away again without showing anything
    onMounted(() => declined.value && exit());

    return { declined, loading, onEnter, exit };
  },
});
